import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  countryId: 'IN',
  tests: null,
  breakouts: null,
  carriers: null,
  newTest: null
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/tests/index.js